import { NotificationCard } from '../../components/Card';
import { Flex, Center, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { LayersThree01 } from '@kula-ai/icons-core';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
  useRequisitionData,
} from './components';
import { KText } from '@/ui-library/components';

const RequisitionAssigned = ({ notification = {}, onClose = () => {} }) => {
  const { content } = notification;
  const {
    requisition_id,
    requisition_ids,
    buildRequisitionDetails,
    assigned_by_name,
  } = useRequisitionData(notification);
  const history = useHistory();

  const detailsData = buildRequisitionDetails([
    { label: 'Created by', value: assigned_by_name },
  ]);

  const handleViewRequisition = () => {
    if (requisition_id || requisition_ids?.[0]) {
      history.push(
        `/requisitions?view=${requisition_id || requisition_ids?.[0]}`
      );
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <LayersThree01
          size={16}
          color="var(--kula-colors-pastel-2-dark)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText>{content}</KText>

        <RequisitionDetailsSection>
          <RequisitionDetailsList data={detailsData} />
        </RequisitionDetailsSection>

        <Button
          variant="primary"
          onClick={handleViewRequisition}
          size="sm"
          w="fit-content"
        >
          View requisition
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const RequisitionAssignedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <RequisitionAssigned notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
